import {useEffect, useState} from "react";

import {FormFieldType} from "@pg-mono/form";
import {pick} from "@pg-mono/nodash";

import {getSentLeadFormValuesFromStorage} from "../../application/utils/lead/sent_lead_form_values";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

export const formFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField
};

const defaultValues = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};

export type formValuesType = typeof defaultValues;

export const useCalculatorFormInitialValues = (): formValuesType => {
    const [initialValues, setInitialValues] = useState<formValuesType>(defaultValues);

    const {data: userProfileDataFromStore} = useGetUserProfileQuery();
    const isAuthenticated = !!userProfileDataFromStore;

    useEffect(() => {
        const userProfileDataFromLocalStorage = getSentLeadFormValuesFromStorage();

        if (userProfileDataFromStore) {
            // Fill application form with user data from API
            setInitialValues((prev) => {
                return {...prev, ...fromJsonValues(formFields, {...userProfileDataFromStore})};
            });

            return;
        }

        // Fill application form with user data from local storage
        if (!!userProfileDataFromLocalStorage) {
            setInitialValues((prev) => {
                return {
                    ...prev,
                    ...fromJsonValues(formFields, pick(userProfileDataFromLocalStorage, ["email", "name", "phone"]))
                };
            });
        }
    }, [isAuthenticated, userProfileDataFromStore]);

    return initialValues;
};
import {useEffect, useState} from "react";

import {FormFieldType} from "@pg-mono/form";
import {pick} from "@pg-mono/nodash";

import {getSentLeadFormValuesFromStorage} from "../../application/utils/lead/sent_lead_form_values";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

export const formFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField
};

const defaultValues = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};

export type formValuesType = typeof defaultValues;

export const useCalculatorFormInitialValues = (): formValuesType => {
    const [initialValues, setInitialValues] = useState<formValuesType>(defaultValues);

    const {data: userProfileDataFromStore} = useGetUserProfileQuery();
    const isAuthenticated = !!userProfileDataFromStore;

    useEffect(() => {
        const userProfileDataFromLocalStorage = getSentLeadFormValuesFromStorage();

        if (userProfileDataFromStore) {
            // Fill application form with user data from API
            setInitialValues((prev) => {
                return {...prev, ...fromJsonValues(formFields, {...userProfileDataFromStore})};
            });

            return;
        }

        // Fill application form with user data from local storage
        if (!!userProfileDataFromLocalStorage) {
            setInitialValues((prev) => {
                return {
                    ...prev,
                    ...fromJsonValues(formFields, pick(userProfileDataFromLocalStorage, ["email", "name", "phone"]))
                };
            });
        }
    }, [isAuthenticated, userProfileDataFromStore]);

    return initialValues;
};
